var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftAnimalLogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 183,
    height: 194,
    viewBox: "0 0 183 194",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_513)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.772 149.506C108.772 149.506 121.871 170.637 110.511 172.334C99.1502 174.03 97.4116 151.203 97.4116 151.203L108.772 149.506Z",
    fill: "url(#paint0_radial_2_513)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M113.939 170.598C112.751 171.013 111.495 171.199 110.238 171.148C107.161 171.01 104.231 169.475 102.159 167.211C101.915 166.93 101.656 166.663 101.383 166.411C103.352 170.166 106.257 172.969 110.51 172.334C112.096 172.097 113.204 171.481 113.939 170.598Z",
    fill: "#FFADEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.3638 130.341C68.3638 130.341 70.4717 136.576 66.1645 138.747C61.8573 140.917 33.0749 136.783 32.2538 131.232C31.4327 125.68 67.8318 126.098 68.3638 130.341Z",
    fill: "url(#paint1_radial_2_513)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.881 111.655C112.881 111.655 115.207 117.812 119.912 116.754C124.618 115.697 144.24 94.2276 141.352 89.4156C138.465 84.6036 110.601 108.038 112.881 111.655Z",
    fill: "url(#paint2_radial_2_513)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.433 89.0363C134.433 89.0363 138.611 110.925 139.178 111.272C139.745 111.619 140.662 111.401 141.159 111.205C141.655 111.01 137.584 87.9376 137.584 87.9376L134.433 89.0363Z",
    fill: "#ED7218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.133 89.4964C149.521 85.4046 154.641 73.7092 150.57 63.374C146.499 53.0389 134.777 47.9777 124.39 52.0696C114.003 56.1614 108.882 67.8568 112.954 78.192C117.025 88.5271 128.746 93.5883 139.133 89.4964Z",
    fill: "#FF3381"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.033 68.8079C115.417 62.8059 120.052 57.7135 125.485 55.0775C129.519 53.1198 133.955 52.2746 138.436 51.7691C135.682 50.8187 132.753 50.4743 129.849 50.7596C126.946 51.0449 124.136 51.9532 121.614 53.4219C119.092 54.8906 116.918 56.885 115.24 59.2679C113.562 61.6508 112.421 64.3658 111.894 67.226C111.368 70.0862 111.47 73.0239 112.192 75.8371C112.913 78.6504 114.239 81.2723 116.077 83.5228C117.914 85.7732 120.221 87.5988 122.838 88.8739C125.454 90.149 128.319 90.8435 131.235 90.9095C128.166 90.2291 125.322 88.7862 122.967 86.7149C119.408 83.599 117.026 79.2851 115.774 74.7281C115.244 72.8019 114.905 70.803 115.033 68.8079Z",
    fill: "#FF73A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.056 74.4764C149.477 75.9848 148.233 77.7508 146.81 79.4098C145.118 81.382 142.905 82.9448 140.654 84.1841C136.332 86.5635 130.459 88.4936 125.672 86.3696C120.885 84.2456 118.834 78.4648 118.967 73.5714C119.101 68.6306 121.148 62.0891 125.717 59.7028C130.019 57.4559 137.2 58.5985 140.948 61.6715C145.238 65.1888 143.807 71.9288 140.295 75.2076C136.372 78.8698 128.102 80.1918 125.327 74.458C122.912 69.47 126.883 64.2931 132.05 64.6185C134.355 64.7636 136.611 66.3735 137.213 68.6957C137.598 70.1798 136.966 71.6277 135.63 72.2712C133.514 73.2902 131.552 70.7633 132.699 68.787C132.722 68.7561 132.732 68.7176 132.726 68.6797C132.72 68.6419 132.7 68.608 132.669 68.5853C132.638 68.5627 132.599 68.5532 132.561 68.559C132.523 68.5649 132.489 68.5855 132.466 68.6163C130.432 71.0569 133.281 74.3813 136.086 73.2967C140.238 71.6918 139.253 66.6912 136.476 64.2179C133.49 61.5587 128.897 62.214 125.905 64.2876C122.531 66.6251 122.043 71.1362 123.146 74.855C124.597 79.7447 129.259 81.5014 133.817 81.2185C138.781 80.9103 143.353 77.8945 145.689 73.499C147.951 69.2427 147.427 64.2264 144.602 60.3218C141.683 56.2884 135.689 55.0577 131.102 55.0329C127.732 55.0147 124.53 55.9702 121.964 58.1948C119.361 60.4525 117.972 64.0281 116.976 67.2656C114.989 73.7294 115.692 81.0644 120.44 86.206C125.48 91.6639 132.529 91.0166 138.81 88.6551C141.253 87.7363 144.203 86.218 146.715 84.2215C149.196 81.411 150.857 77.9785 151.517 74.2983C151.432 74.2935 151.347 74.307 151.267 74.3377C151.188 74.3684 151.116 74.4157 151.056 74.4764Z",
    fill: "#FF73A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.138 74.684C149.55 76.1728 148.296 77.9105 146.863 79.5451C145.16 81.4885 142.941 83.0353 140.687 84.2675C136.358 86.6318 130.489 88.5709 125.737 86.5353C120.985 84.4997 118.992 78.865 119.167 74.0788C119.344 69.2464 121.441 62.8317 126.014 60.4585C130.322 58.2237 137.468 59.2784 141.176 62.2507C145.421 65.6525 143.936 72.2558 140.407 75.4928C136.465 79.108 128.212 80.4728 125.497 74.8903C123.134 70.0337 127.136 64.9368 132.283 65.2099C134.579 65.3317 136.813 66.8864 137.393 69.1518C137.763 70.5997 137.121 72.0211 135.784 72.6619C133.666 73.6773 131.732 71.223 132.893 69.2805C132.914 69.2499 132.922 69.2124 132.916 69.176C132.91 69.1396 132.889 69.1072 132.859 69.0857C132.829 69.0642 132.792 69.0553 132.755 69.0609C132.718 69.0664 132.685 69.0861 132.663 69.1156C130.614 71.5199 133.424 74.7458 136.229 73.6608C140.381 72.0546 139.443 67.174 136.697 64.7796C133.745 62.2053 129.162 62.8862 126.161 64.94C122.779 67.2552 122.254 71.6706 123.32 75.2975C124.723 80.0662 129.354 81.7433 133.899 81.4267C138.849 81.0823 143.431 78.0937 145.798 73.7745C148.089 69.5928 147.61 64.6919 144.829 60.8986C141.955 56.9798 135.993 55.8287 131.422 55.8444C128.063 55.856 124.863 56.8178 122.287 59.0161C119.674 61.2464 118.258 64.7547 117.237 67.9296C115.2 74.2679 115.838 81.434 120.524 86.4204C125.499 91.7134 132.529 91.019 138.809 88.655C141.252 87.7352 144.205 86.2248 146.727 84.2506C149.212 81.5034 150.897 78.1329 151.598 74.505C151.513 74.5013 151.428 74.5152 151.349 74.5461C151.27 74.5769 151.198 74.6239 151.138 74.684Z",
    fill: "#C40E7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.8749 150.892C79.8749 150.892 61.2517 167.52 71.6628 172.306C82.074 177.093 90.2861 155.678 90.2861 155.678L79.8749 150.892Z",
    fill: "url(#paint3_radial_2_513)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.6772 153.607C89.6772 153.607 81.1064 176.997 92.5704 176.312C104.034 175.627 101.141 152.922 101.141 152.922L89.6772 153.607Z",
    fill: "url(#paint4_radial_2_513)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.561 135.653C118.561 135.653 143.521 135.112 139.171 145.713C134.821 156.315 114.21 146.254 114.21 146.254L118.561 135.653Z",
    fill: "url(#paint5_radial_2_513)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.243 144.323C113.243 144.323 135.464 155.584 126.613 162.901C117.761 170.219 104.392 151.64 104.392 151.64L113.243 144.323Z",
    fill: "url(#paint6_radial_2_513)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.967 111.475C129.23 123.22 126.173 134.915 120.592 145.357C117.206 151.694 113.154 158.324 106.354 161.003C99.5533 163.683 92.0685 161.596 85.2693 159.271C74.0664 155.441 63.8547 148.973 58.2304 138.158C48.1743 118.819 49.4708 85.9311 73.112 76.6176C96.7533 67.3041 120.133 90.4733 125.967 111.475Z",
    fill: "url(#paint7_radial_2_513)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M113.999 98.2609C114.499 102.382 114.645 106.595 113.781 110.661C113.11 113.819 111.844 116.823 110.445 119.737C106.389 128.182 100.96 136.253 93.2357 141.589C85.511 146.925 74.9177 149.791 66.2654 146.2C65.223 145.767 63.4456 144.939 62.4386 144.419C67.8169 150.978 75.0967 155.375 83.1242 158.394C86.4614 157.929 90.9063 156.752 94.066 155.607C106.673 151.039 117.917 142.409 124.852 130.962C125.572 129.774 126.237 128.552 126.857 127.308C127.622 122.115 127.445 116.8 125.966 111.475C123.662 103.183 118.623 94.5554 111.913 87.7203C112.866 91.1775 113.563 94.7005 113.999 98.2609Z",
    fill: "#5D0D75"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M55.8075 101.738C57.316 93.9089 61.6293 86.6603 67.7123 81.4686C70.9698 78.7061 74.6779 76.5205 78.6744 75.0072C76.7737 75.3668 74.9111 75.9061 73.1119 76.6177C49.4701 85.9308 48.1738 118.819 58.2307 138.158C63.4653 148.224 72.6742 154.523 82.9569 158.435C73.2935 151.214 63.5646 143.315 59.0363 132.23C57.2766 127.92 56.3908 123.304 55.7891 118.687C55.0563 113.062 54.7333 107.314 55.8075 101.738Z",
    fill: "#FFADEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.0879 130.305C76.0879 130.305 100.328 148.702 108.762 117.434C108.762 117.434 90.2778 130.888 76.0879 130.305Z",
    fill: "#5D0D75"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M73.0117 172.055C71.4351 169.589 70.9129 166.499 71.4688 163.622C71.8177 161.816 72.5639 160.113 73.3046 158.427L73.8235 157.247C69.5189 162.475 65.4928 169.469 71.6628 172.305C72.2859 172.595 72.9459 172.8 73.6248 172.912C73.406 172.637 73.2014 172.351 73.0117 172.055Z",
    fill: "#FFADEF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M90.1311 173.435C88.441 170.29 87.599 166.771 87.1245 163.219C86.0459 169.407 86.1662 176.304 92.0577 176.327C91.3258 175.425 90.6808 174.457 90.1311 173.435Z",
    fill: "#FFADEF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M126.14 157.495C126.764 159.015 127.155 160.621 127.299 162.259C131.363 157.95 125.766 152.497 120.476 148.74C122.685 151.456 124.824 154.263 126.14 157.495Z",
    fill: "#FFADEF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M139.171 145.713C141.745 139.44 134.058 137.069 127.351 136.178C130.145 137.448 132.728 139.182 134.806 141.425C136.355 143.089 137.575 145.029 138.403 147.145C138.708 146.696 138.966 146.216 139.171 145.713Z",
    fill: "#FFADEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.2576 106.643C71.8255 103.662 75.6167 95.2951 72.7254 87.9555C69.8342 80.616 61.3554 77.0828 53.7876 80.064C46.2197 83.0452 42.4285 91.4118 45.3197 98.7513C48.211 106.091 56.6898 109.624 64.2576 106.643Z",
    fill: "#FFADEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.7235 105.287C71.2914 102.306 75.2021 94.2427 72.4584 87.2776C69.7146 80.3125 61.3554 77.0828 53.7876 80.064C46.2197 83.0452 42.309 91.1083 45.0527 98.0734C47.7964 105.039 56.1557 108.268 63.7235 105.287Z",
    fill: "#5D0D75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.8747 102.603C69.0642 99.7707 72.9287 92.4897 70.5063 86.3403C68.0839 80.1909 60.2919 77.5018 53.1025 80.3339C45.913 83.166 42.0485 90.447 44.4709 96.5964C46.8932 102.746 54.6852 105.435 61.8747 102.603Z",
    fill: "url(#paint8_radial_2_513)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M61.8749 102.602C69.0644 99.7702 72.9292 92.4897 70.5066 86.3398C69.9706 84.9832 69.1555 83.7542 68.1136 82.7317C68.0145 83.7538 67.7679 84.7569 67.3815 85.7099C66.2447 88.5042 64.0942 90.7808 61.7319 92.6675C58.6777 95.1071 55.11 97.0359 51.2418 97.6041C49.0455 97.9335 46.8046 97.7619 44.688 97.1022C47.3293 102.89 54.8857 105.356 61.8749 102.602Z",
    fill: "#DBA75C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.4759 97.9831C63.1246 96.9397 64.4704 94.0592 63.4817 91.5492C62.4929 89.0393 59.5442 87.8505 56.8954 88.8939C54.2466 89.9373 52.9009 92.8179 53.8896 95.3278C54.8783 97.8377 57.8271 99.0265 60.4759 97.9831Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5715 97.0269C61.968 96.0829 63.2094 93.5372 62.3443 91.341C61.4792 89.1449 58.8351 88.1298 56.4386 89.0739C54.0421 90.0179 52.8007 92.5636 53.6658 94.7597C54.5309 96.9559 57.175 97.9709 59.5715 97.0269Z",
    fill: "#574120"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4427 90.5223C56.2468 89.461 55.2239 88.7618 54.158 88.9607C53.0921 89.1595 52.3868 90.1811 52.5827 91.2424C52.7787 92.3037 53.8016 93.0029 54.8675 92.804C55.9334 92.6051 56.6386 91.5836 56.4427 90.5223Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1123 87.8121C64.6636 86.2985 64.6939 83.8227 63.18 82.2823C61.6661 80.7419 59.1812 80.7202 57.6299 82.2339C56.0786 83.7475 56.0483 86.2233 57.5622 87.7637C59.0762 89.3041 61.561 89.3258 63.1123 87.8121Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.4045 92.7981C106.972 89.8169 110.764 81.4502 107.872 74.1107C104.981 66.7712 96.5024 63.238 88.9344 66.2192C81.3665 69.2004 77.5752 77.5671 80.4665 84.9066C83.3577 92.2461 91.8365 95.7793 99.4045 92.7981Z",
    fill: "#FFADEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.8704 91.4422C106.438 88.461 110.349 80.3979 107.605 73.4328C104.862 66.4676 96.5024 63.238 88.9344 66.2192C81.3665 69.2004 77.4557 77.2635 80.1994 84.2287C82.9432 91.1938 91.3024 94.4234 98.8704 91.4422Z",
    fill: "#5D0D75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.0215 88.7581C104.211 85.9259 108.075 78.645 105.653 72.4956C103.231 66.3462 95.4387 63.6571 88.2492 66.4892C81.0597 69.3213 77.1952 76.6022 79.6176 82.7516C82.04 88.901 89.832 91.5902 97.0215 88.7581Z",
    fill: "url(#paint9_radial_2_513)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M97.0217 88.7575C104.211 85.9254 108.076 78.645 105.653 72.4951C105.117 71.1385 104.302 69.9095 103.26 68.8869C103.161 69.9092 102.915 70.9124 102.529 71.8655C101.392 74.6598 99.2411 76.9364 96.8788 78.8232C93.8246 81.2628 90.2569 83.1915 86.3886 83.7598C84.1924 84.0892 81.9515 83.9176 79.8349 83.2579C82.4769 89.0454 90.033 91.5106 97.0217 88.7575Z",
    fill: "#DBA75C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.6226 84.1384C98.2714 83.095 99.6171 80.2144 98.6284 77.7045C97.6397 75.1946 94.6909 74.0058 92.0421 75.0492C89.3933 76.0926 88.0476 78.9732 89.0363 81.4831C90.025 83.993 92.9738 85.1818 95.6226 84.1384Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.7182 83.1822C97.1147 82.2381 98.3562 79.6925 97.491 77.4963C96.6259 75.3002 93.9818 74.2851 91.5853 75.2291C89.1888 76.1732 87.9474 78.7188 88.8125 80.915C89.6777 83.1112 92.3217 84.1262 94.7182 83.1822Z",
    fill: "#574120"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.5785 76.6198C91.3506 75.5649 90.3069 74.8968 89.2473 75.1275C88.1878 75.3581 87.5135 76.4003 87.7414 77.4552C87.9693 78.5101 89.013 79.1782 90.0726 78.9476C91.1322 78.7169 91.8064 77.6747 91.5785 76.6198Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.0903 74.1232C99.7277 72.7025 99.9036 70.2322 98.4832 68.6057C97.0629 66.9792 94.5841 66.8124 92.9467 68.2332C91.3093 69.6539 91.1334 72.1242 92.5537 73.7507C93.9741 75.3772 96.4529 75.5439 98.0903 74.1232Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.724 129.832C81.724 129.832 80.5525 134.843 81.7586 136.006C82.9648 137.169 88.6825 136.108 89.3353 135.106C89.9881 134.103 88.2973 128.284 88.2973 128.284C88.2973 128.284 83.1714 129.707 81.724 129.832Z",
    fill: "#FFF5DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.837 120.525C103.837 120.525 108.365 123.292 108.276 124.965C108.187 126.638 103.282 129.761 102.121 129.473C100.96 129.186 97.9736 123.876 97.9736 123.876C97.9736 123.876 102.693 121.422 103.837 120.525Z",
    fill: "#FFF5DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.348 58.3396C116.731 57.4646 116.33 56.4482 115.454 56.0695C114.577 55.6909 113.555 56.0932 113.172 56.9683C112.789 57.8434 113.189 58.8597 114.066 59.2384C114.943 59.6171 115.965 59.2147 116.348 58.3396Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2_513",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-452.756 171.379) rotate(-157.786) scale(23.8406 47.8242)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.008,
    stopColor: "#DF6FF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E469A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_2_513",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-150.415 64.3269) rotate(-125.444) scale(64.8063 26.7463)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.008,
    stopColor: "#DF6FF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E469A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_2_513",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-12.2872 -102.43) rotate(-96.5886) scale(70.0822 24.734)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.008,
    stopColor: "#DF6FF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E469A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_2_513",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(49.2019 169.493) rotate(-21.5007) scale(33.867 33.6804)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.008,
    stopColor: "#DF6FF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E469A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_2_513",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(143.543 80.0642) rotate(-46.9464) scale(33.0617 34.5024)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.008,
    stopColor: "#DF6FF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E469A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_2_513",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-127.245 237.35) rotate(158.499) scale(33.8674 33.6804)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.008,
    stopColor: "#DF6FF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E469A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_2_513",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-262.909 210.086) rotate(-176.055) scale(33.0617 34.5024)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.008,
    stopColor: "#DF6FF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E469A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_2_513",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(98.7738 99.8471) rotate(-21.5007) scale(57.996 57.6834)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.008,
    stopColor: "#DF6FF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E469A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_2_513",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.2181 84.2211) rotate(-21.5007) scale(30.0092 29.8462)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.027,
    stopColor: "#FFECD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBA75C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_2_513",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(82.351 70.3818) rotate(-21.5007) scale(30.0092 29.8462)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.027,
    stopColor: "#FFECD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBA75C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_513"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 135,
    height: 155,
    fill: "white",
    transform: "translate(0 49.4795) rotate(-21.5007)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftAnimalLogin);
export default __webpack_public_path__ + "static/media/leftAnimalLogin.1b9537b8d27e40bd54d1ee73977cc57c.svg";
export { ForwardRef as ReactComponent };